<!-- <ion-picker-legacy
    [isOpen]="isPickerOpen"
    [columns]="pickerColumns"
    [buttons]="pickerButtons"
    (didDismiss)="setOpen(false)"
></ion-picker-legacy> -->

<ion-modal [isOpen]="isPickerOpen" (didDismiss)="dismissPicker('cancel')">
    <ng-template>
        <ion-toolbar>
            <ion-buttons slot="start">
                <ion-button (click)="dismissPicker('cancel')">Cancel</ion-button>
            </ion-buttons>
            <ion-buttons slot="end">
                <ion-button (click)="dismissPicker('confirm')">Done</ion-button>
            </ion-buttons>
        </ion-toolbar>
        <ion-picker>
            <ion-picker-column [value]="minValue" (ionChange)="onMinChange($event)">
                @for (option of colOptions; track $index) {
                    <ion-picker-column-option [value]="option.value">{{ option.text }}</ion-picker-column-option>
                }
                <div slot="suffix">m</div>
            </ion-picker-column>

            <ion-picker-column [value]="secValue" (ionChange)="onSecChange($event)">
                @for (option of colOptions; track $index) {
                    <ion-picker-column-option [value]="option.value">{{ option.text }}</ion-picker-column-option>
                }
                <div slot="suffix">s</div>
            </ion-picker-column>
        </ion-picker>
    </ng-template>
</ion-modal>